
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.946 3.907a.5.5 0 01.708 0L6.05 7.304l3.397-3.397a.5.5 0 11.707.707l-3.75 3.75a.5.5 0 01-.707 0l-3.75-3.75a.5.5 0 010-.707z","fill":"#282E3E"}})])
          )
        }
      }
    